import { axiosInstance } from "@src/api/axiosConfig";
import { axiosPath } from "@src/api/axiosPath";
import { TICKET_TYPE } from "@src/components/deungi/common/enum";
import { useQuery } from "react-query";

export const useTicketCount = async (ticketType?: TICKET_TYPE) => {
    const response = await axiosInstance.get(axiosPath.ticketCount + (ticketType ? `/${ticketType}` : ""));
    if (!response.status) throw new Error("Problem fetching data");
    return response;
};
// 법인 등기 티켓
export const useCorpTicketCount = async () => {
    const response = await axiosInstance.get(axiosPath.corpTicketCount + "/8");
    if (!response.status) throw new Error("Problem fetching data");
    return response?.data;
};

//* 티켓 개수 가져오기
export const useFindOneTicketCount = (ticketType: number, enabled?: boolean) => {
    return useQuery<{ curHaveCnt: number; dayLeft7Cnt: number }>(
        [ticketType, "ticketCount"],
        async () => {
            const result = await axiosInstance
                .get(`${axiosPath.adTicketCount}/${ticketType}`)
                .then((res) => {
                    return res?.data;
                })
                .catch((err) => {
                    console.log("err>>", err);
                    return err;
                });
            return result;
        },
        { enabled },
    );
};
